import { PartnerMessagesView } from "@/components/partner/PartnerViews";

const PartnerMessages = () => <PartnerMessagesView />;

export default PartnerMessages;
